<template>
  <ModalBox>
    <div class="link-share-modal">
      <h3>{{ title }}</h3>

      <span>{{ message }}:</span>

      <div
        ref="shareLink"
        class="share__link mt-2"
      >
        <a
          ref="shareLinkInner"
          class="share__link__inner"

          :href="shareOptions.url"
          @click.prevent="selectLink"
        >{{ shareOptions.url }}</a>
      </div>
    </div>

    <ShareBanner
      slot="button-group"
      :options="shareOptions"
    />
  </ModalBox>
</template>

<script>
import ShareBanner from '@/scripts/Components/Molecules/ShareBanner';
import ModalBox from '@/scripts/Components/Organisms/ModalBox';

export default {
  components: {
    ModalBox,
    ShareBanner,
  },
  props: {
    title: {
      type: String,
      default: I18n.t('share.actions.share'),
    },
    message: {
      type: String,
      default: I18n.t('share.label.public_link'),
    },
    shareOptions: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.shareLink.scrollLeft = this.$refs.shareLinkInner.offsetWidth;
    });
  },
  methods: {
    selectLink() {
      const textEl = this.$refs.shareLinkInner;
      const doc = document;
      let range, selection;

      if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(textEl);
        range.select();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(textEl);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/stylesheets/exports/_component-entry';

.share__link {
  overflow-x: auto;
  width: 100%;
  overflow-y: hidden;
  background-color: #F0F0F0;
  padding: 8px 8px;
  padding-right: 16px;
  font-size: 1.5em;

  margin-bottom: 2em;
}

.share__link__inner {
  white-space: nowrap;
  margin: 0;
  font-family: $font-family-monospace;
}
</style>
